.status__bar {
  margin-bottom: 15px;
  height: 48px;
  display: flex;
  align-items: center;

  ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-weight: 400;
    line-height: 16.1px;
    text-align: center;
    position: relative;

    li {
      position: relative;
      z-index: 2;
      background-color: #fff;

      &:not(:last-child) {
        padding-right: 10px;
      }

      &:not(:first-child) {
        padding-left: 20px;
      }

      span {
        width: 30px;
        height: 30px;
        background: #F9F9FB;
        color: #575757;
        font-family: var(--font-family, 'sofia-pro, sans-serif');
        font-size: 16px;
        font-weight: 700;
        line-height: 18.4px;
        text-align: center;
        display: inline-flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-right: 7px;
      }

      &.active {
        span {
          color: #fff;
          background: #888888;
        }
      }
    }

    li.active {
      span {
        color: #fff;
        background: #888888;
      }
    }
  }

  ul:before {
    content: "";
    border-top: 1px solid #000;
    position: absolute;
    top: 50%;
    width: 100%;
    height: 1px;
    left: 0;
    z-index: 2;
  }

}